// Vertical category switcher for the FAQ section. Server-rendered markup
// renders each tab button next to its own panel and shows every panel
// (progressive enhancement). Once JS runs, tabs are moved into their own
// list so the tab column and the active panel lay out independently —
// switching panels never changes the height of the tab column.
class FaqTabs extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const { signal } = this.#controller;

    const tablist = this.querySelector('.faq__tablist');
    const tabs = Array.from(this.querySelectorAll('.faq__tab'));

    if (tablist) {
      for (const tab of tabs) tablist.append(tab);
    }

    this.tabs = tabs;
    this.panels = Array.from(this.querySelectorAll('.faq__panel'));

    if (this.tabs.length) this.#activateTab(this.tabs[0]);

    this.addEventListener('click', this.#handleClick, { signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /** @param {HTMLElement} tab */
  #activateTab(tab) {
    for (const otherTab of this.tabs) {
      const isActive = otherTab === tab;

      otherTab.setAttribute('aria-expanded', String(isActive));
      otherTab.classList.toggle('faq__tab--active', isActive);
    }

    const targetId = tab.getAttribute('aria-controls');

    for (const panel of this.panels) {
      panel.hidden = panel.id !== targetId;
    }
  }

  #handleClick = (event) => {
    const tab = event.target instanceof Element ? event.target.closest('.faq__tab') : null;

    if (!tab || !this.tabs.includes(tab)) return;

    this.#activateTab(tab);
  };
}

if (!customElements.get('faq-tabs')) {
  customElements.define('faq-tabs', FaqTabs);
}
